module.exports = __webpack_public_path__ + "static/img/hongmeng.3f83b98d.png";